import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { Expanded, FiltersStorage } from '../../api/interfaces/user';
import { SnackbarService } from '../../utils/snackbar/snackbar.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LogoutService {

  private url = environment.apiUrl + '/';

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json'
    }),
    withCredentials: true,
  };

  constructor(
    private snack: SnackbarService,
    private router: Router,
    private http: HttpClient
  ) { }

  logoutCookie(): Observable<any> {
    return this.http.get<any>(this.url + `logout`,  this.httpOptions);
  }

  public logOut() {
    sessionStorage.setItem('logout','true');
    this.logoutCookie().subscribe(response => { 
    },
      error => {
      });
  }

  public notAllowed() {
    sessionStorage.setItem('notAllowed','true');
    this.logoutCookie().subscribe(response => { 
    },
      error => {
        console.error(error);
      });
  }

  public expirado() {
    const logout: boolean = JSON.parse(sessionStorage.getItem('logout'));
    const notAllowed: boolean = JSON.parse(sessionStorage.getItem('notAllowed'));

    if(logout || notAllowed) {
      if(logout) {
        this.snack.snackTranslate('snacks.logout.success');
      }
      if(notAllowed) {
        this.snack.snackTranslate('snacks.logout.notAllowed');
      }
    } else {
      this.snack.snackTranslate('snacks.logout.expired');
    }
    this.clearStorage();
    this.router.navigate(['']);
  }

  clearStorage() {
    localStorage.clear();
    sessionStorage.clear();
  }
}
